/*
 * @Author: LGY 18588437913@163.com
 * @Date: 2023-02-20 11:41:29
 * @LastEditors: LGY 18588437913@163.com
 * @LastEditTime: 2023-02-20 11:58:25
 * @FilePath: /dz-signup-stupc/src/store/index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from "vue";
import Vuex from "vuex";
import { host } from "@/utils/config.js";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    showUrl: "/",
  },
  mutations: {},
  actions: {},
  modules: {},
});
